import { Anchor, Heading, Paragraph, Popover, Text } from '@zillow/constellation-10';

const FAIR_HOUSING_ACCESSIBILITY_URL = 'https://www.hud.gov/helping-americans/disabilities';

const DisabledAccessAmenityTooltip = () => (
  <Popover
    tone="info"
    header={<Heading level={2}>Accessibility</Heading>}
    body={
      <Paragraph>
        Select this if your property adheres to the{' '}
        <Anchor href={FAIR_HOUSING_ACCESSIBILITY_URL} target="_blank" rel="noopener noreferrer">
          Fair Housing Act Accessibility Requirements
        </Anchor>
        , or other similar design standard. If you&apos;re not sure if your rental meets those requirements, it&apos;s
        best to leave <Text textStyle="body-bold">disabled access</Text> unchecked and describe any accessibility
        features in the listing description.
      </Paragraph>
    }
    trigger={<Popover.Trigger aria-label="Learn more about disabled access" css={{ alignSelf: 'center' }} />}
  />
);

export default DisabledAccessAmenityTooltip;
